export const SelectActionTypes = {
  buttonClick: 'buttonClick'
};